import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { StyledProcessingSpinner } from "./styles";

let ProcessingSpinner = ({ className }) => (
    <StyledProcessingSpinner
        className={`${className || ""} loadingio-spinner-reload-xsznurzt17q`}
    >
        <div className="ldio-nzxgsp1te9">
            <div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </StyledProcessingSpinner>
);

ProcessingSpinner.propTypes = {
    className: PropTypes.string
};

ProcessingSpinner = styled(ProcessingSpinner)``;

export default ProcessingSpinner;
